// // assets
// import { UserOutlined } from '@ant-design/icons';

// // icons
// const icons = {
//   UserOutlined
// };

// // ==============================|| MENU ITEMS - USER MASTER ||============================== //

// const userMaster = {
//   id: 'group-user',
//   title: 'User Master',
//   type: 'group',
//   children: [
//     {
//       id: 'empMaster',
//       title: 'Employee Master',
//       type: 'item',
//       url: '/employee-master',
//       icon: icons.UserOutlined,
//       breadcrumbs: false
//     },
//      {
//       id: 'thirdPary',
//       title: 'Third-party Employee',
//       type: 'item',
//       url: '/third-party',
//       icon: icons.UserOutlined,
//       breadcrumbs: false
//     }
//   ]
// };




// // userMaster.js
// import { UserOutlined } from '@ant-design/icons';
// const icons = { UserOutlined };

// const userMaster = (roleID) => {
//   return roleID == 1
//     ? {
//         id: 'group-user',
//         title: 'User Master',
//         type: 'group',
//         children: [
//           {
//             id: 'empMaster',
//             title: 'Employee Master',
//             type: 'item',
//             url: '/employee-master',
//             icon: icons.UserOutlined,
//             breadcrumbs: false
//           },
//           {
//             id: 'thirdPary',
//             title: 'Third-party Employee',
//             type: 'item',
//             url: '/third-party',
//             icon: icons.UserOutlined,
//             breadcrumbs: false
//           }
//         ]
//       }
//     : {
//         id: 'group-user',
//         title: '',
//         type: 'group',
//         children: []
//       };
// };

// export default userMaster;






// // assets
// import { UserOutlined } from '@ant-design/icons';

// // icons
// const icons = {
//   UserOutlined
// };

// // ==============================|| MENU ITEMS - USER MASTER ||============================== //

// const userMaster = {
//   id: 'group-user',
//   title: 'User Master',
//   type: 'colllapse',     // 🔥 IMPORTANT (makes menu expandable)
//   children: [
//     {
//       id: 'empMaster',
//       title: 'Employee Master',
//       type: 'item',
//       url: '/employee-master',
//       icon: icons.UserOutlined,
//       breadcrumbs: false
//     },
//      {
//       id: 'thirdPary',
//       title: 'Third-party Employee',
//       type: 'item',
//       url: '/third-party',
//       icon: icons.UserOutlined,
//       breadcrumbs: false
//     }
//   ]
// };




// export default userMaster;






// // assets
// import { UserOutlined } from '@ant-design/icons';

// const icons = {
//   UserOutlined
// };

// // ==============================|| MENU ITEMS - USER MASTER ||============================== //

// const userMaster = (roleID) => {
//   if (roleID != 1) {
//     return {
//       id: 'group-user',
//       title: '',
//       type: 'group',
//       children: []
//     };
//   }

//   return {
//     id: 'group-user',
//     title: 'User Master',
//     type: 'collapse',     // ✔ expandable menu
//     children: [
//       {
//         id: 'empMaster',
//         title: 'Employee Master',
//         type: 'item',
//         url: '/employee-master',
//         icon: icons.UserOutlined,
//         breadcrumbs: false
//       },
//       {
//         id: 'thirdPary',
//         title: 'Third-party Employee',
//         type: 'item',
//         url: '/third-party',
//         icon: icons.UserOutlined,
//         breadcrumbs: false
//       }
//     ]
//   };
// };

// export default userMaster;





import { UserOutlined } from '@ant-design/icons';

const icons = { UserOutlined };
const roles = [0,1,2];

const userMaster = {
  id: 'group-user',
  title: 'User Master',
  type: 'collapse',
  icon: icons.UserOutlined,
  roles,
  children: [
    {
      id: 'empMaster',
      title: 'Employee Master',
      type: 'item',
      url: '/employee-master',
      icon: icons.UserOutlined,
      breadcrumbs: false,
      roles
    },
    {
      id: 'thirdPary',
      title: 'Third-party Associates',
      type: 'item',
      url: '/third-party',
      icon: icons.UserOutlined,
      breadcrumbs: false,
      roles
    }
  ]
};

export default userMaster;
